export default {
  prepareSequenceImages: Array(31)
    .fill('')
    .map((v, i) =>
        require(`../../../Box_sequences/00_TV_clean_box/TV_clean_box${i < 10 ? `0${i}` : i}.jpg`)
    ),
  designSliderImage: require('../../../product drawing/kinoko table.png'),
  designImageList: [
    {
      number: 1,
      side: 'BOTTOM',
      image: require('../../../parts/kinokotable/k01.png'),
    },
    {
      number: 2,
      side: 'SIDE',
      image: require('../../../parts/kinokotable/k02.png'),
    },
    {
      number: 3,
      side: 'MIDDLE',
      sideNumber: '1',
      image: require('../../../parts/kinokotable/k03.png'),
    },
    {
      number: '',
      side: '',
      image: require('../../../parts/kinokotable/k04.png'),
    },
    {
      number: 4,
      side: 'MIDDLE',
      sideNumber: '2',
      image: require('../../../parts/kinokotable//k05.png'),
    },
    {
      number: 5,
      side: 'TOP',
      sideNumber: '1',
      image: require('../../../parts/kinokotable/k06.png'),
    },
    {
      number: 6,
      side: 'TOP',
      sideNumber: '2',
      image: require('../../../parts/kinokotable/k07.png'),
    },
    {
      number: '7',
      side: 'TOPSIDE',
      image: require('../../../parts/kinokotable/k08.png'),
    },
  ],
  cutOutPartsImage: require('../../../parts/kinokotable/k09.png'),
  cutOutPartsFoldImage: require('../../../parts/kinokotable/k10.png'),
  gluePartsImage: require('../../../parts/kinokotable/k11.png'),
  assembleSequenceImages: Array(76)
    .fill('')
    .map((v, i) =>
      require(`../../../sequences/18_Kinoko_Table_sequence/KinokoTable${
        i < 10 ? `0${i}` : i
      }.jpg`)
    ),
  completeImage: require('../../../complete/Kinoko-Table-01.jpg'),
  completeImagePc: require('../../../complete/Kinoko-Table-01.jpg'),
};
